<!-- eslint-disable vue/no-v-html -->
<!-- Security Review: v-html usage is safe here as content is sanitized through cleanHTML utility which removes dangerous scripts, event handlers, and malicious protocols -->
<!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
<!-- Justification: Content is sanitized via cleanHTML utility before rendering. The cleanHTML function removes script tags, event handlers, and dangerous protocols (javascript:, data:) -->
<template>
  <span v-html="cleanHTML(string)"></span>
</template>
<script setup lang="ts">
import { cleanHTML } from "@/utils/clean-html";
export interface Props {
  string: string;
}
defineProps<Props>();
</script>
